<template>
    <div class="pd-12 top-border-bottom">
        <a class="exch-breadcrumb-heading-sec" @click="$router.go(-1)">
            <img  src="@/assets/images/back.webp" alt="back" >
            <h5 class="text-capitalize">{{ $t('deposit', 'Deposit') }}</h5>
        </a>
    </div>
    <div class="exch-deposit-wrapper">
        <div class="mr-row-sec">
            <div class="multiSteps-container">
                <div class="multiSteps-points">
                    <div class="points-circle active">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="14" viewBox="0 0 11 10" fill="none" class="w-3 h-3"><path d="M4.31258 7.43734L1.97925 5.104L2.42716 4.65609L4.31258 6.5415L8.31258 2.5415L8.7605 2.98942L4.31258 7.43734Z" fill="#E7EAEF" stroke="#E7EAEF" stroke-width="0.8"></path></svg>
                    </div>
                    <div class="points-border"></div>
                    <div class="points-circle">2</div>
                    <div class="points-border"></div>
                    <div class="points-circle">3</div>
                    <div class="points-border"></div>
                    <div class="points-circle">4</div>
                </div>
                <div class="multiSteps-name">
                    <div class="title-wrap active">{{ $t('enter-amt', 'Enter amount') }}</div>
                    <div class="title-wrap">{{ $t('payment-method', 'Payment Method') }}</div>
                    <div class="title-wrap">{{ $t('make-deposit', 'Make Deposit') }}</div>
                    <div class="title-wrap">{{ $t('proof', 'Proof') }}</div>
                </div>
            </div>
            <div class="exch-payment-step-content-wrapper">
                <div class="wallet-list-wrapper">
                    <div class="exch-deposit-amount-sec-step-1">
                        <div class="deposit-amount-sec">
                            <div class="amount-field amount_filed_stake_val">
                                <label>{{ $t('please-enter-the-amount-to-deposit', 'Please Enter The Amount To Deposit') }}</label>
                                <input type="text" class="form-control" :placeholder="$t('enter-amt', 'Enter amount')"  v-model="amount" @input="amount = $helper.sanitizeNumber(+amount, +walletConfig?.deposit_range?.max || 99999999)">
                                <div class="min_max_title">
                                <span class="input-tag-right">{{ $t('min', 'Min') }}:  {{ walletConfig?.deposit_range?.min ? walletConfig?.deposit_range.min: 100 }}</span>
                                    <span class="input-tag-right">{{ $t('max', 'Max') }}:  {{ walletConfig?.deposit_range?.max ? walletConfig?.deposit_range?.max : 10000000 }}</span>
                                </div>
                            </div>
                            <div class="amount-value" v-if="walletConfig?.stake_button">
                                <ul class="edit_stake_field_btn">
                                    <li v-for="(stake, index) in (userTransactionStakes ? [...userTransactionStakes.slice(0, 4)] : walletConfig?.stake_button)" :key="index">
                                        <a @click="setAmount(stake)">
                                            <span class="btn-thm">+{{ stake }}</span>
                                        </a>
                                    </li>
                                </ul>
                                <div class="edit-stake-btn">
                                    <a class="login-btn" data-bs-toggle="modal" data-bs-target="#editStakeModal" href="javascript:void(0)">
                                        <span>
                                            <i class="fa-regular fa-pen-to-square"></i>
                                        </span>
                                        {{ $t('edit-stake', 'Edit Stake') }}
                                    </a>
                                    <a class="green-theme-btn" @click="!isButtonDisabled && confirmAmountModal()" 
                                        :disabled="isButtonDisabled" :class="{ 'disabled-btn': isButtonDisabled }">
                                        {{ $t('proceed', 'Proceed') }}
                                    </a>
                                </div>
                            </div>
                        </div>

                        <!-- <span>Bonus</span>
                        <div class="deposit-amount-sec mt-2">
                            <div class="amount-field">
                                <div v-for="(promo, index) in promoBonusData" :key="index" class="copy-refer-code">
                                    <input type="text" class="form-control text-capitalize" :placeholder="`${promo.bonusType} & get Bonus`" readonly>
                                    <button class="exch-sm-btn blue-bg">Promo</button>
                                </div>
                            </div>
                        </div> -->

                        <!-- <a class="green-theme-btn mt-4 w-100" @click="!isButtonDisabled && confirmAmountModal()" 
                            :disabled="isButtonDisabled" :class="{ 'disabled-btn': isButtonDisabled }">
                            {{ $t('proceed-to-select-payment-method', 'Proceed To Select Payment Method') }}
                        </a> -->
                    </div>
                </div>
            </div>
        </div>
         <WalletInstructions walletType='deposit' />
    </div>
   
    <TutorialVideo type = "2" v-if="Object.values(walletConfig?.deposit_video).some(val => val?.trim() !== '')" />
    <!-- Wallet Stake Modal -->
    <div class="modal fade exch-rule-modal" id="editStakeModal" aria-hidden="true" aria-labelledby="editStakeModalLabel" tabindex="-1" data-bs-backdrop="static">
        <div class="modal-dialog modal-dialog-centered">
            <WalletStakeModal ref="resetStakeCall" @updateStakes="saveButtonClick" v-if="walletConfig" :stakes="walletConfig?.stake_button"/>
        </div>
    </div>
    <!-- Deposit Breakdown Modal -->
    <div class="modal fade depositGetBonus-modal" ref="finalDepositModal" id="depositGetBonusModal" tabindex="-1" aria-labelledby="depositGetBonusModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="depositGetBonusModalLabel">{{ $t('deposit-breakdown', 'Deposit Breakdown') }}</h5>
                    <button type="button" id="closeBtn" class="btn-close close-circle" data-bs-dismiss="modal" aria-label="Close">
                        <i class="fa fa-close"></i>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="refer-wining-sec">
                        <span class="refer-wining-star1">
                            <svg width="24" height="24" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path opacity="0.73" id="Vector" d="M0.405762 6.38867C10.1454 10.6987 10.1454 10.6987 14.7051 1.00031C10.1454 10.6987 10.1454 10.6987 19.885 15.0087C10.1454 10.6987 10.1454 10.6987 5.58558 20.397C10.1454 10.6987 10.1454 10.6987 0.405762 6.38867Z" fill="#FFF"></path>
                            </svg>
                        </span>
                        <span class="refer-wining-star2">
                            <svg width="24" height="24" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path opacity="0.73" id="Vector" d="M0.405762 6.38867C10.1454 10.6987 10.1454 10.6987 14.7051 1.00031C10.1454 10.6987 10.1454 10.6987 19.885 15.0087C10.1454 10.6987 10.1454 10.6987 5.58558 20.397C10.1454 10.6987 10.1454 10.6987 0.405762 6.38867Z" fill="#FFF"></path>
                            </svg>
                        </span>
                        <span class="refer-wining-star3">
                            <svg width="24" height="24" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path opacity="0.73" id="Vector" d="M0.405762 6.38867C10.1454 10.6987 10.1454 10.6987 14.7051 1.00031C10.1454 10.6987 10.1454 10.6987 19.885 15.0087C10.1454 10.6987 10.1454 10.6987 5.58558 20.397C10.1454 10.6987 10.1454 10.6987 0.405762 6.38867Z" fill="#FFF"></path>
                            </svg>
                        </span>
                        <div class="wining-title">
                            <h4>{{ $t('deposit-amount', 'Deposit Amount') }} <span>{{ amount }}</span></h4>
                        </div>
                    </div>
                    <button type="button" class="green-theme-btn mt-4 w-100" @click="goToDepositMethods()">{{ $t('confirm', 'Confirm') }}</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Modal } from 'bootstrap';
import { defineAsyncComponent } from 'vue';
import { mapGetters } from 'vuex';
import { setWalletStakeValue} from '../services/wallet.js';
import WalletStakeModal from '../components/WalletStakeModal.vue';
import TutorialVideo from '../components/TutorialVideo.vue';
import WalletInstructions from '../components/WalletInstructions.vue';
export default {
    name: "WalletDeposit",
    inject: ['walletConfig'],
    data() {
        return {
            walletData: null,
            loading: false,
            amount: null,
            promoBonusData: [
                {
                    bonusType: "first deposit",
                    welcomeBalance: 0,
                    modeType: "percentage",
                    percentage: 5
                },
                {
                    bonusType: "every deposit",
                    welcomeBalance: 0,
                    modeType: "percentage",
                    percentage: 3
                }
            ]
        }
    },
    components:{
        WalletStakeModal,
        TutorialVideo,
        WalletInstructions
    },
    computed: {
        ...mapGetters(['userTransactionStakes']),
        isButtonDisabled() {
            const minAmount = this.walletConfig?.deposit_range?.min || 100;
            return this.amount === null || this.amount < minAmount;
        },
    },
    mounted() {
        if(this.$auth.user.isDemo){
            this.$errorToast("Wallet access is restricted for demo user");
            setTimeout(() => {
                this.$router.push({name: 'Home'})
            }, 500);
        }else{
            // this.getWalletLimitsServiceCall();
        }
    },
    methods: {
        setAmount(stake) {
            try {
                const response = setWalletStakeValue(stake, this.amount, this.walletConfig)
                if(response){
                    this.amount =  response; 
                }
            } catch (error) {
                this.$errorToast(error)
            }
        },
        saveButtonClick(stakes) {
            this.walletData.stake = stakes;
        },
        getWalletLimitsServiceCall() {
            this.loading = true;
            this.$apiCall('get', 'GET_STAKES', null, 'walletConfig', null).then((response) => {
                this.loading = false;
                this.walletData = null;
                if (response) {
                    if (response.status == 200) {
                        if (response?.data?.status == 0) {
                            this.$errorToast(response?.data?.debug[0]);
                        } else {
                            this.walletData = response?.data?.data;
                            if (!this.walletData?.stake) {
                                if (!this.walletData.stake) {
                                    this.walletData.stake = {}; 
                                }
                                this.walletData.stake.stake1 = 100;
                                this.walletData.stake.stake2 = 500;
                                this.walletData.stake.stake3 = 1000;
                                this.walletData.stake.stake4 = 5000;
                            }
                        }
                    }
                }
            }).catch(error => {
                this.loading = false;
                if (error) {
                    this.$errorToast(error[0]);
                }
            });
        },
        confirmAmountModal() {
            if (this.amount == null || 
                this.amount < (!this.walletData?.range?.minimum_deposit ? 100 : this.walletData?.range?.minimum_deposit) || 
                this.amount > (!this.walletData?.range?.maximum_deposit ? 99999999 : this.walletData?.range?.maximum_deposit)) {
                    const minAmount = !this.walletData?.range?.minimum_deposit ? 100 : this.walletData?.range?.minimum_deposit;
                    const maxAmount = !this.walletData?.range?.maximum_deposit ? 99999999 : this.walletData?.range?.maximum_deposit;
                    this.$errorToast(`${this.$t('amount-should-be-in-between', 'Amount Should Be In Between')} ${minAmount} To ${maxAmount}.`);
            } else {
                this.amountConfirmation();
            }
        },
        amountConfirmation() {
            if (this.$refs.finalDepositModal) {
                const modalInstance = new Modal(this.$refs.finalDepositModal);
                modalInstance.show();
            }
        },
        goToDepositMethods() {
            this.$store.dispatch('setDepositAmount', this.amount);
            const closeButton = document.getElementById('closeBtn');
            if (closeButton) {
                closeButton.click();
            }
            this.$router.push({ name: 'deposit-payment-method' });
        },
        resetStake() {
            // this.$refs.resetStakeCall.resetChips();
        },
    }
}
</script>